import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";

import { ValidationService } from "../../../../common/validation/validation.service";
import { createUserData } from "../../../../common/authentication/aws-sdk-helper";
import { ForgotPasswordResetFormValue } from "../../../../models";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { NavigationService } from "../../../../common/navigation/navigation.service";

@Component({
	selector: "sdp-forgot-password-change",
	templateUrl: "./forgot-password-change.component.html"
})
export class ForgotPasswordChangeComponent implements OnInit {
	@Output()
	public showLoadingBar = new EventEmitter<void>();

	@Output()
	public hideLoadingBar = new EventEmitter<void>();

	public email = "";
	public verificationCode = "";
	public newPassword = "";
	public passwordType = "password";
	public form: FormGroup;
	public readonly passwordIcon = { type: "material", name: "remove_red_eye", cssClass: "sdp-password-show-icon" };

	constructor(
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private validationService: ValidationService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService,
		private navigationService: NavigationService
	) {
		this.form = this.formBuilder.group({
			password: [
				"",
				Validators.compose([
					Validators.required,
					this.validationService.createConfirmPasswordValidatorForPassword("password", "confirmPassword")
				])
			],
			confirmPassword: [
				"",
				this.validationService.createConfirmPasswordValidatorForConfirmPassword("password", "confirmPassword")
			]
		});
	}

	public ngOnInit() {
		this.route.queryParams.subscribe((params: Params) => {
			this.email = params["email"];
			this.verificationCode = params["code"];
		});
	}

	public forgotPasswordChange() {
		if (this.form.valid) {
			const formValue = <ForgotPasswordResetFormValue>this.form.getRawValue();
			this.newPassword = formValue.password;
			const cognitoUser = createUserData(this.email);
			this.showLoadingBar.next();
			cognitoUser.confirmPassword(
				this.verificationCode,
				this.newPassword,
				{
					onSuccess: () => {
						this.hideLoadingBar.next();
						this.back();
					},
					onFailure: (err: Error) => {
						this.hideLoadingBar.next();
						this.snackbarService.open(this.translateService.translate(err));
					}
				}
			);
		}
	}

	public back() {
		this.navigationService.navigate(["/login/login"]);
	}
}
